import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { AddictionAuthModule, AuthService } from 'addiction-auth';
import { authServiceInit } from './auth/auth-initializer';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { authConfig, authModuleConfig } from './auth/auth.config';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthJWTInterceptor } from './auth/auth-jwt.interceptor';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { register } from 'swiper/element/bundle';
import { provideLottieOptions } from 'ngx-lottie';
import { ToastrModule } from 'ngx-toastr';
import player from 'lottie-web';

register();

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAppInitializer(() => {
            const authService = inject(AuthService);
            return authServiceInit(authService)();
        }),
        provideHttpClient(),
        importProvidersFrom(
            AddictionAuthModule.forRoot(environment as unknown as Record<string, unknown>, authConfig, authModuleConfig),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: createTranslateLoader,
                    deps: [HttpClient],
                },
                defaultLanguage: 'it-IT',
                useDefaultLang: true,
                isolate: false,
            }),
            ToastrModule.forRoot({
                positionClass: 'toast-bottom-center',
            })
        ),
        provideHttpClient(withInterceptors([AuthJWTInterceptor, ErrorInterceptor])),
        provideLottieOptions({
          player: () => player,
        })
    ],
};

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
